/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const registerPushTokenBodySchema = z.object({
  token: z.string(),
  platform: z.enum(['ios', 'android']),
});

export type IRegisterPushTokenBody = z.infer<typeof registerPushTokenBodySchema>;
